import { SharedFileRequestContextType } from "@wingspanhq/wingspan-api-sdk";

export function selectorIsSharedFileDriversLicenseContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return (
    !!contextType &&
    contextType === SharedFileRequestContextType.DRIVERS_LICENSE
  );
}
